module.exports = "# MME Level 1\nYouTube: 8ucjPVwH7Hw\n\n## Notes\n(3:19)\n\n\n# MME Level 2\nYouTube: VNd21qg2fPE\n\n## Notes\n(2:25)\n\n\n# MME Level 3\nYouTube: O-sEHAMM0hw\n\n## Notes\n(5:41)\n\n\n# MME Level 4\nYouTube: QX4SqqRm5AQ\n\n## Notes\n(10:49)\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/13_mme/mme.fr_CA.md
// module id = 1685
// module chunks = 2